import { useRef, useEffect, useImperativeHandle, forwardRef, useState } from "react";
import { Button } from "./ui/button";
import { Eraser } from "lucide-react";

const SignaturePad = forwardRef(({ onChange }, ref) => {
  const canvasRef = useRef(null);
  const drawing = useRef(false);
  const [empty, setEmpty] = useState(true);

  useEffect(() => {
    const canvas = canvasRef.current;
    const ratio = window.devicePixelRatio || 1;
    const rect = canvas.getBoundingClientRect();
    canvas.width = rect.width * ratio;
    canvas.height = rect.height * ratio;
    const ctx = canvas.getContext("2d");
    ctx.scale(ratio, ratio);
    ctx.lineWidth = 2.2;
    ctx.lineCap = "round";
    ctx.lineJoin = "round";
    ctx.strokeStyle = "#111111";
  }, []);

  const pos = (e) => {
    const rect = canvasRef.current.getBoundingClientRect();
    const t = e.touches ? e.touches[0] : e;
    return { x: t.clientX - rect.left, y: t.clientY - rect.top };
  };
  const start = (e) => {
    e.preventDefault();
    drawing.current = true;
    const ctx = canvasRef.current.getContext("2d");
    const { x, y } = pos(e);
    ctx.beginPath();
    ctx.moveTo(x, y);
  };
  const move = (e) => {
    if (!drawing.current) return;
    e.preventDefault();
    const ctx = canvasRef.current.getContext("2d");
    const { x, y } = pos(e);
    ctx.lineTo(x, y);
    ctx.stroke();
    if (empty) { setEmpty(false); onChange?.(false); }
  };
  const end = () => { drawing.current = false; };

  const clear = () => {
    const canvas = canvasRef.current;
    const ctx = canvas.getContext("2d");
    ctx.clearRect(0, 0, canvas.width, canvas.height);
    setEmpty(true);
    onChange?.(true);
  };

  useImperativeHandle(ref, () => ({
    isEmpty: () => empty,
    toDataURL: () => (empty ? null : canvasRef.current.toDataURL("image/png")),
    clear,
  }));

  return (
    <div>
      <div className="relative rounded-lg border border-dashed border-border bg-white overflow-hidden" style={{ touchAction: "none" }}>
        <canvas
          ref={canvasRef}
          data-testid="signature-canvas"
          className="w-full h-40 block cursor-crosshair"
          onMouseDown={start} onMouseMove={move} onMouseUp={end} onMouseLeave={end}
          onTouchStart={start} onTouchMove={move} onTouchEnd={end}
        />
        {empty && (
          <span className="pointer-events-none absolute inset-0 flex items-center justify-center text-xs text-neutral-400">
            Firma qui con il dito o il mouse
          </span>
        )}
      </div>
      <div className="flex justify-end mt-2">
        <Button type="button" variant="ghost" size="sm" onClick={clear} data-testid="signature-clear" className="text-muted-foreground">
          <Eraser className="h-3.5 w-3.5 mr-1.5" /> Cancella
        </Button>
      </div>
    </div>
  );
});

SignaturePad.displayName = "SignaturePad";
export default SignaturePad;
